import { SiteItemData, SiteVideoData } from "../../../../interfaces";
import { isWcmEditor } from "../../../../../config/serverConfig";

interface VerticalVideoGalleryBepoItemProps {
    videoItem: SiteItemData & { category: any }
    videoIndex: number
    itemMargin: number
    currentPromoIndex: number
    isPromoCarouselInView: boolean
    disableAutoScrollIntoView?: boolean
    onVideoEnded: () => void
    onOpenVideoGalleryView: (e) => void
    onPromoMouseHover: (currentPromoIndex: number, videoRef?: HTMLVideoElement) => void
    imagesDomain?: string
}

interface VerticalVideoGalleryBepoItemState {
    isMouseHover: boolean
}

export class VerticalVideoGalleryBepoItem extends React.Component<VerticalVideoGalleryBepoItemProps, VerticalVideoGalleryBepoItemState> {
    constructor(props) {
        super(props);
        this.state = {
            isMouseHover: false,
        }
    }

    private videoRef;

    componentDidUpdate(prevProps: VerticalVideoGalleryBepoItemProps) {
        const { isMouseHover } = this.state;
        const { videoIndex, currentPromoIndex, disableAutoScrollIntoView } = this.props;

        if (disableAutoScrollIntoView) return;

        if (!isMouseHover && currentPromoIndex !== prevProps.currentPromoIndex && currentPromoIndex === videoIndex) {
            if (this.videoRef) {
                const videoElement = document.getElementById(`verticalVideoGalleryBepoItem_${videoIndex}`);
                const videoRect = videoElement.getBoundingClientRect();
                const containerElement = document.querySelector(".verticalVideoGalleryBepoComponent .frame_forList");
                const containerRect = containerElement.getBoundingClientRect();


                if (videoRect.left < containerRect.left || videoRect.right > containerRect.right) {
                    const scrollElement = document.querySelector(".verticalVideoGalleryBepoComponent .slotListWrapper");
                    scrollElement.scrollBy({ behavior: 'smooth', left: videoRect.left - containerRect.left });
                }
            }
        }
    }

    private onMouseHover = () => {
        const { videoIndex, onPromoMouseHover } = this.props;

        this.setState({ isMouseHover: true });
        onPromoMouseHover(videoIndex);
        if (this.videoRef) this.videoRef.play();
    }

    private onMouseLeave = () => {
        const { onPromoMouseHover } = this.props;

        this.setState({ isMouseHover: false });
        onPromoMouseHover(null, this.videoRef);
    }

    private secondsToMinutesHandler = (seconds: number) => {
        const minutes = Math.floor(seconds / 60).toString().padStart(2, "0");
        const newSeconds = (seconds % 60).toString().padStart(2, "0");
        return `${minutes}:${newSeconds}`;
    }

    private onVideoError = () => {
        console.error("Video failed to load");

        if (!this.state.isMouseHover) {
            this.props.onVideoEnded();
        }
    }

    public render() {
        const { isMouseHover } = this.state;
        const { videoItem: { media, title, category }, onOpenVideoGalleryView, videoIndex, onVideoEnded, currentPromoIndex, isPromoCarouselInView, itemMargin, imagesDomain } = this.props;
        const { duration, poster, promoPath } = media as SiteVideoData;
        const shouldDisplayPromo = !isWcmEditor() && isPromoCarouselInView && promoPath && currentPromoIndex === videoIndex;
        const slotClasses = `slotView ${shouldDisplayPromo ? "promo-playing" : ""}`;
        const categoryText = category && category.textToShow;
        const categoryImage = category && category.categoryIcon ? category.categoryIcon : null;
        const plainTitle = (title || "").replace(/<(?:.|\n)*?>/gm, "").replace(/&nbsp;/gi, " ").trim();
        const hasTitle = plainTitle.length > 0;

        return (
            <div className={slotClasses} id={`verticalVideoGalleryBepoItem_${videoIndex}`} style={{ marginLeft: itemMargin }} onMouseEnter={this.onMouseHover} onMouseLeave={this.onMouseLeave} onClick={() => onOpenVideoGalleryView(videoIndex)}>
                <div className="media-container">
                    {shouldDisplayPromo &&
                        <video
                            muted
                            src={promoPath}
                            autoPlay={true}
                            poster={poster}
                            loop={isMouseHover}
                            className="promoVideo"
                            onEnded={onVideoEnded}
                            onError={this.onVideoError}
                            ref={ref => this.videoRef = ref}
                        >
                        </video>
                    }

                    <img src={poster} alt={media.title || "Video poster"}  />
                </div>

                <div className={`contentDiv ${hasTitle ? "has-title" : ""}`}>
                    {hasTitle &&
                         <div data_analytics={media.title} className="videoTitle" dangerouslySetInnerHTML={{ __html: title }} />
                    }
                    <div className="category-details">
                            {categoryImage && <img width={30} height={30} src={imagesDomain ? `${imagesDomain}${categoryImage}` : categoryImage} alt={categoryText} />}

                            {categoryText && <div className="categoryName">{categoryText}</div>}
                        </div>
                    
                    <div className="videoDuration">
                        <span>{this.secondsToMinutesHandler(Math.round(duration))}</span>
                        <span className="durationLogo"></span>
                    </div>
                </div>
            </div>
        )
    }
}

